import api from "Common/Client/Interceptor";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// SuperAdmin (authenticated) expert-invite + registered-expert calls.
export const expertInviteService = {
  // Send a new expert invite.
  sendInvite: async ({ email, firstName, lastName }) => {
    const res = await api.post("/indv/ExpertInvites/send", { email, firstName, lastName });
    return res.data;
  },

  // Load the invitation list for the Invitations tab.
  getInvites: async () => {
    const res = await api.get("/indv/ExpertInvites/list");
    return res.data;
  },

  // Resend a pending invitation (one-hour cooldown enforced by backend).
  resendInvite: async (inviteId) => {
    const res = await api.post(`/indv/ExpertInvites/resend/${inviteId}`);
    return res.data;
  },

  // Revoke a pending invitation.
  revokeInvite: async (inviteId) => {
    const res = await api.post(`/indv/ExpertInvites/revoke/${inviteId}`);
    return res.data;
  },

  // Load experts who have already accepted/registered.
  getRegisteredExperts: async () => {
    const res = await api.get("/indv/Experts/Admin/Get-List");
    return res.data;
  },
};

// Public (anonymous) accept-invite calls — no auth header, like the other
// public accept pages.
export const validateExpertInviteToken = async (token) => {
  const res = await axios.get(`${BASE_URL}/indv/ExpertInvites/validate`, {
    params: { token },
  });
  return res.data;
};

export const acceptExpertInvite = async ({ token, password }) => {
  const res = await axios.post(`${BASE_URL}/indv/ExpertInvites/accept`, {
    token,
    password,
  });
  return res.data;
};
